import React from 'react';
import PropTypes from 'prop-types';
import WalletApplyingIcon from './WalletApplyingIcon';
import './WalletCard.scss';

/**
 * Displays only summary rows supplied by the wallet's authoritative integration.
 * @param {object} props - Summary title and labelled values.
 * @param {string} props.title - Summary heading.
 * @param {boolean} [props.loading] - A selection mutation is in progress.
 * @param {string} [props.loadingText] - Status while the mutation is pending.
 * @param {Array} props.rows - Authoritative labelled values.
 * @returns {React.ReactElement} Wallet summary.
 */
export default function WalletSummary({
  title,
  rows,
  loading = false,
  loadingText = 'Aplicando puntos…',
}) {
  if (loading)
    return (
      <div className="wallet-summary">
        <div
          className="wallet-summary__body wallet-summary__loading"
          role="status"
          aria-busy="true"
        >
          <WalletApplyingIcon />
          <p>{loadingText}</p>
        </div>
      </div>
    );
  return (
    <div className="wallet-summary">
      <div className="wallet-summary__body">
        <h3 className="wallet-summary__title">{title}</h3>
        <dl className="wallet-summary__rows">
          {rows.map(({ label, value }) => (
            <div className="wallet-summary__row" key={label}>
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
WalletSummary.propTypes = {
  loading: PropTypes.bool,
  loadingText: PropTypes.string,
  title: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string.isRequired, value: PropTypes.node }),
  ).isRequired,
};
